import { Component, OnInit, Output, EventEmitter, ViewChild, Input, OnChanges } from '@angular/core';
import { UserDataService } from "../../../services/user-data.service";
import { ReportList } from "../../../model/LoginUserInfo/ReportList";
import * as _ from 'underscore';
import { ReportDetails } from "../../../model/report/report-detail";
import { ReportService } from "../../../services/reports/report.service";
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { CheckboxListComponent } from '../../../common/component/checkbox-list/checkbox-list.component';
import { DatePipe } from "@angular/common";
import { PiwikProUtils } from '../../../common/utility/piwikProUtils';
import { models } from 'powerbi-client';
import { TabDataService } from '../../../services/tab-data.service';
import { dateRangeValidator } from '../../../common/utility/date-validator';

@Component({
  selector: 'app-inquiry-reports',

  templateUrl: './inquiry-reports.component.html',
  styleUrl: './inquiry-reports.component.scss'
})
export class InquiryReportsComponent implements OnInit, OnChanges {

  // Reports Field
  assignedGroups = [];
  reportTypeList: ReportList[] = [];
  requestReports: ReportDetails[] = [];
  @ViewChild(CheckboxListComponent, { static: true }) checkboxListComponent: any;

  // Report Reactive Form
  reportForm: FormGroup;
  groupList = [];
  reportRequested = false;
  isDropdownOpen: boolean = false;

  @Input() modalOpen: boolean;
  @Output() modalClosed = new EventEmitter();

  @Input() selectedTab: string;
  @Input() shouldDisplayReport: boolean = false;
  @Output() reportConfigCreated = new EventEmitter<any>();
  @Output() reportTypeSelected = new EventEmitter<any>();

  maxDate = new Date();
  minDate = new Date();
  startMaxDate = new Date();
  endDateMax= new Date();
  isAllGroupsSelected = false;

  //message
  errorMessage: string;
  successMessage: string;
  invalidDateRangeError: string;
  dateExceedsThreeMonthsError:string
  showSpinner: boolean = false;
  standardReports = [];
  reportConfig = {
    type: 'report',
    id: '',
    embedUrl: '',
    accessToken: '', tokenType: models.TokenType.Embed,
    hostname: "https://app.powerbi.com",
    settings: {
      panes: {
        filters: { visible: false },
        pageNavigation: { visible: false }
      }
    }
  };

  constructor(private readonly tabDataService: TabDataService,private readonly fb: FormBuilder, private readonly userService: UserDataService, private readonly reportService: ReportService, private readonly datePipe: DatePipe) {
    this.showSpinner = true;
    this.getReportRelatedDetails();
    const today = new Date();
    today.setHours(0, 0, 0, 0);
    today.setMonth(today.getMonth());
    today.setDate(today.getDate()); // Set to the last day of the current month

    // Calculate date 3 months ago
    const threeMonthsAgo = new Date();
    threeMonthsAgo.setMonth(today.getMonth() - 3);

    // Handle edge cases where subtracting 3 months lands on an invalid date
    if (threeMonthsAgo.getDate() !== today.getDate()) {
      // Set to last day of the month if original date isn't valid (e.g., Feb 31)
      threeMonthsAgo.setDate(0);
    }
    // Initiate Report form
    let selReportType = this.reportTypeList[0];
    this.reportForm = this.fb.group({
      reportType: [selReportType, [Validators.required]],
      startDate: [threeMonthsAgo, [Validators.required]],
      endDate: [today, [Validators.required]]
    }, { validators: dateRangeValidator() });
    this.reportForm.get('endDate').setValue(today)
    this.reportService.getPowerBIMisReport().subscribe({
      next: reports => {
        this.showSpinner = false;
        if (reports.results.length > 0) {
          this.standardReports = reports.results.filter(item =>
            item.embedReports?.some(report => report.reportName !== 'Dashboard')
          );


        }
      },
      error: error => {
        this.showSpinner = false;
        console.error("Error fetching Power BI MIS report:", error);
      }
    })

  }

  ngOnInit() {

    this.reportForm.get('endDate')?.valueChanges.subscribe((start: Date) => {
      this.startMaxDate = start;
    });
  }

  ngOnChanges() {
    if (this.modalOpen) {
      this.resetForm();
    }
  }

  /**
   * Method to get report details to populate the fields.
   */
  getReportRelatedDetails(): void {
    this.userService.LocalGetLoginUserInfo().subscribe(loginUserInfo => {

      // Populate Assigned Group Name
      loginUserInfo.myGroups.forEach(group => {
        let grp = {
          name: group.groupName,
          value: group.groupName,
          label: group.groupName
        }
        this.assignedGroups.push(grp);
      });

      // Populate Report Type list
      this.reportTypeList = [...loginUserInfo.reportList];

      // Sort the report list array by name
      this.reportTypeList = _.sortBy(this.reportTypeList, function (i) { return i.value.toLowerCase(); });
    });
  }
  /**
   * Method to request report.
   * @param reportDetail : Report criteria.
   */
  onRequestReport(requestReport: FormGroup): void {
    const details = requestReport.value;
    const groupList = this.groupList.map(group => group.name);
    const selReportType = details.reportType?.key ?? this.reportTypeList[0].key;
    const startDate = this.reportForm.get('startDate')?.value;
    const endDate = this.reportForm.get('endDate')?.value;
    const startDateUS = startDate?.toLocaleDateString('en-US'); // MM/DD/YYYY
    const endDateUS = endDate?.toLocaleDateString('en-US');     // MM/DD/YYYY
    this.reportTypeSelected.emit(selReportType);

    // Encode individual parameters
    const groupParams = groupList
      .map(group => 'rp:pGroup=' + encodeURIComponent(group))
      .join('&');
    const startDateParam = 'rp:pStart_Date=' + encodeURIComponent(startDateUS);
    const endDateParam = 'rp:pEnd_Date=' + encodeURIComponent(endDateUS);
    if (this.groupList.length === 0) {
      this.errorMessage = 'Please select at least one group. ';
    }
    else {
      this.errorMessage = '';
    }
    if (this.reportForm.errors?.dateRangeInvalid) {
      this.invalidDateRangeError = ' Start Date must be before End Date.';
    }
    else {
      this.invalidDateRangeError = '';
    }
    if (this.reportForm.errors?.dateRangeExceedsThreeMonths) {
      this.dateExceedsThreeMonthsError = ' Date range cannot exceed 3 months. ';
    }
    else {
      this.dateExceedsThreeMonthsError = '';
    }
    if (this.groupList.length > 0 && !this.reportForm.errors?.dateRangeInvalid && !this.reportForm.errors?.dateRangeExceedsThreeMonths) {
      this.reportRequested = true;
      this.errorMessage = null;
      this.standardReports.forEach(result => {
        result.embedReports.forEach(report => {
          // Construct final embed URL
          const urlHasParams = report.embedUrl.includes('?');
          const joinChar = urlHasParams ? '&' : '?';

          const fullEmbedUrl = report.embedUrl + joinChar + `${groupParams}&${startDateParam}&${endDateParam}` +'&toolbar=false';
          if ((report.reportName)?.toLowerCase() === selReportType.toLowerCase() && report.reportType === 'PaginatedReport') {
            this.reportConfig = {
              type: 'report',
              id: report.reportId,
              embedUrl: fullEmbedUrl,
              accessToken: result.embedToken.token,
              tokenType: models.TokenType.Embed,
              hostname: "https://app.powerbi.com",
              settings: {
                panes: {
                  filters: { visible: false },
                  pageNavigation: { visible: false }
                },
              }
            };
            this.reportConfigCreated.emit(this.reportConfig);
            this.tabDataService.sendTabData(selReportType, 0, 'report', true)
          };
        });
      });
    }
    else {
      console.log('Please select at least one group and ensure the date range is valid.');
    }
  }

  handleSelectAll(isSelected: boolean): void {
    this.isAllGroupsSelected = isSelected;
      if(isSelected) {
        this.groupList = this.assignedGroups;
      }
      else {
        this.groupList = [];
      }
    }
  /**
   *
   * @param reportForm: Report Form instance
   */
  clearAndClose(reportForm: FormGroup): void {
    this.resetForm();
    this.modalClosed.emit();
    PiwikProUtils.trackJsonDataForEvent(this.userService.loggedInUserInfo.pivotProConfigEnabled, this.userService.loggedInUserInfo.userId, "Menu", "REQUEST MIS REPORT - Cancel", "Click", "REQUEST MIS REPORT - Cancel", 0);
  }

  /**
   * Method to get the selected group.
   * @param group
   */
  getAssignedGroups(group: any): void {
    this.groupList = [...group];
  }

  resetForm() {
    this.reportForm.reset();
    this.checkboxListComponent.clearFilterText();
    this.checkboxListComponent.resetCheckList();
    this.errorMessage = '';
    this.successMessage = '';
  }

}
